import type { EventSales as GQLItem } from '../../../generated/api.graphql';

export type EventSales = {
  totalTicketsSalesToday: number;
  totalTicketsSoldToday: number;
  totalTicketsSales: number;
  totalTicketsSold: number;
  totalTicketsAvailable: number;
  totalTickets: number;
  totalTicketsOnHold: number;
  totalSalesLimit: number;
  /**
   * `totalSales` and `ticketsSold` are selected only by the `aggregatedEventSales` query.
   * `EVENT_LIST_FIELDS` does not request them and `EVENT_LIST_MINIMAL_FIELDS` selects no
   * `ticketTotals` at all, so on an `EventSummary` read from the events list both are `0`.
   * Add them to that fragment before rendering either on a list row.
   */
  totalSales: number;
  ticketsSold: number;
};

export const getNew = (): EventSales => ({
  totalTicketsSalesToday: 0,
  totalTicketsSoldToday: 0,
  totalTicketsSales: 0,
  totalTicketsSold: 0,
  totalTicketsAvailable: 0,
  totalTickets: 0,
  totalTicketsOnHold: 0,
  totalSalesLimit: 0,
  totalSales: 0,
  ticketsSold: 0,
});

export const fromGql = (item: GQLItem): EventSales => ({
  totalTicketsSalesToday: item.totalTicketsSalesToday ?? 0,
  totalTicketsSoldToday: item.totalTicketsSoldToday ?? 0,
  totalTicketsSales: item.totalTicketsSales ?? 0,
  totalTicketsSold: item.totalTicketsSold ?? 0,
  totalTicketsAvailable: item.totalTicketsAvailable ?? 0,
  totalTickets: item.totalTickets ?? 0,
  totalTicketsOnHold: item.totalTicketsOnHold ?? 0,
  totalSalesLimit: item.totalSalesLimit ?? 0,
  totalSales: item.totalSales ?? 0,
  ticketsSold: item.ticketsSold ?? 0,
});
